import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import UserBadge from "../../assets/images/svg-icons-material-io/badge_FILL0_wght400_GRAD0_opsz48.svg";
import SpecialtyDropdown from "../shared/SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";
import validEmail from "../../utils/emailUtils";

function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}
function getDigits(s = "") {
  return String(s).replace(/\D/g, "");
}

function isInvalidPostalCode(s) {
  const d = getDigits(s);
  return d.length > 0 && d.length < 5; // require 5 digits
}

const EditUser = ({ closeEdit, userEditDetails }) => {
  const navigate = useNavigate();
  const { SetSharedObject, userToken, sharedObject } = useUserStore(
    (state) => ({
      SetSharedObject: state.SetSharedObject,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
    })
  );
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const [answers, setAnswers] = useState({});
  const [specialtiesObj, setSpecialtiesObj] = useState({});
  const [processing, SetProcessing] = useState(false);
  const [flag, SetFlag] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [ContactEmail, setContactEmail] = useState("");
  const [Credential, setCredential] = useState("");
  const [NamePrefix, setNamePrefix] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [UserNameDisplay, setUserNameDisplay] = useState("");
  const [Addresses, setAddresses] = useState("");
  const [invalidContactEmail, setInvalidContactEmail] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAddresses({ ...Addresses, [questionId]: answer });
  };
  const ClearFields = async () => {
    let obj = userEditDetails;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      setUpAnswers(obj);
    }
  };
  useEffect(() => {
    let obj = userEditDetails;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      setUpAnswers(obj);
    }
    SetFlag(false);
    SetspecialtiesFlag(false);
    return () => {
      SetSharedObject("hidePermission", false);
      ClearFields();
      SetspecialtiesFlag(false);
    };
  }, [userEditDetails]);
  const setUpAnswers = async (frm) => {
    const add = await listAddress(frm.addresses);
    var editObj = {
      Addresses: await add,
      Administrator: frm.administrator,
      AllowDMEAccess: frm.allowDMEAccess,
      AllowENSAccess: frm.allowENSAccess,
      AllowFormsAccess: frm.allowFormsAccess,
      AllowPriorAuthAccess: frm.allowPriorAuthAccess,
      ClaimsAttachmentPayer: frm.claimsAttachmentPayer,
      ClaimsAttachmentProvider: frm.claimsAttachmentProvider,
      ClaimsAttachmentStaff: frm.claimsAttachmentStaff,
      ContactEmail: frm.contactEmail,
      CreateUsers: frm.createUsers,
      Credential: frm.credential ? frm.credential : "",
      DirectEmail: frm.directEmail,
      DME_Payer: frm.dmE_Payer,
      DME_Provider: frm.dmE_Provider,
      DME_Staff: frm.dmE_Staff,
      DME_Supplier: frm.dmE_Supplier,
      DomainName: frm.domainName,
      FirstName: frm.firstName,
      FullName: frm.fullName,
      HasAddresses: frm.hasAddresses,
      HasSpecialties: frm.hasSpecialties,
      Id: frm.id,
      IDs: ListIds(frm.iDs),
      IsLockedByAdmin: frm.isLockedByAdmin,
      IssueInvites: frm.issueInvites,
      LastLoginTime: frm.lastLoginTime ? frm.lastLoginTime : "",
      LastName: frm.lastName,
      LockoutEnabled: frm.lockoutEnabled,
      LockoutEndDate: frm.lockoutEndDate,
      NPI: frm.npi ? frm.npi : "",
      NamePrefix: frm.namePrefix,
      PreAuthProvider: frm.preAuthProvider,
      PreAuthReviewer: frm.preAuthReviewer,
      PreAuthStaff: frm.preAuthStaff,
      PreAuthSupervisor: frm.preAuthSupervisor,
      RegistrationStatus: frm.registrationStatus,
      RequireIdVerification: frm.requireIdVerification,
      Specialties: listSpecial(frm.specialties),
      Status: frm.status ? frm.status : "",
      TFAEmail: frm.tfaEmail ? frm.tfaEmail : "",
      TFAOn: frm.tfaOn,
      TFAPhone: frm.tfaPhone ? frm.tfaPhone : "",
      TrustedAgent: frm.trustedAgent,
      TwoFactorEnabled: frm.tfaOn,
      UsrTFA: frm.usrTFA,
      UserDirectEmailId: frm.userDirectEmailId,
      UserName: frm.userName,
      UserNameDisplay: frm.userNameDisplay,
      UserTypeString: frm.userTypeString,
      VendorEmailForwardingType: frm.vendorEmailForwardingType,
      VendorEmailForwardingTypeString: frm.vendorEmailForwardingTypeString,
      specializationCode: null,
    };

    if (editObj?.Addresses?.Phone != null) {
      editObj.Addresses.Phone = formatPhoneNumber(frm.addresses[0].phone);
    }
    if (editObj?.Addresses?.Fax != null) {
      editObj.Addresses.Fax = formatPhoneNumber(frm.addresses[0].fax);
    }

    await setAnswers(editObj);
    await SetSharedObject("editObj", editObj);
    await setContactEmail(frm.contactEmail);
    await setCredential(frm.credential);
    await setNamePrefix(frm.namePrefix);
    await setFirstName(frm.firstName);
    await setLastName(frm.lastName);
    await setUserNameDisplay(frm.userNameDisplay);
    await setAddresses(add);
    await setSpecialtiesObj(editObj.Specialties);
  };

  const listAddress = async (frm) => {
    let address = {};
    if (frm && frm.length > 0) {
      let obj = frm[0];
      address = {
        FirstLine: obj.firstLine,
        SecondLine: obj.secondLine,
        City: obj.city,
        State: obj.state,
        PostalCode: obj.postalCode,
        Country: obj.country,
        Phone: obj.phone.substring(0, 10),
        PhoneExt: obj.phone.substring(10, obj.phone.length),
        Fax: obj?.fax?.substring(0, 10),
        FaxExt: obj?.fax?.substring(10, obj.fax.length),
        AddressType: obj.addressType,
        Id: obj.id,
      };
    } else {
      address = {
        FirstLine: "",
        SecondLine: "",
        City: "",
        State: "",
        PostalCode: "",
        Country: "USA",
        Phone: "",
        PhoneExt: "",
        Fax: "",
        FaxExt: "",
        AddressType: 0,
      };
    }
    return address;
  };
  const listSpecial = (frm) => {
    let s = [
      {
        Classification: null,
        Code: null,
        Definition: null,
        Id: null,
        Notes: null,
        Specialization: null,
        Type: null,
      },
    ];
    if (frm && frm.length > 0) {
      let obj = frm[0];
      s = [
        {
          Classification: obj.classification,
          Code: obj.code,
          Definition: obj.definition,
          Id: obj.id,
          Notes: obj.notes,
          Specialization: obj.specialization,
          Type: obj.type,
        },
      ];
    }
    return s;
  };
  const ListIds = (ob) => {
    let temp = [];
    if (ob && ob.length > 0) {
      for (let id of ob) {
        let obj = {
          RecordId: id.recordId,
          IDTypeString: id.idTypeString,
          IDType: id.idType,
          Value: id.value,
          IssuingAuthority: id.issuingAuthority,
        };
        temp.push(obj);
      }
    }

    return temp;
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const updateUser = async () => {
    SetFrmSubmFlag(true);
    SetspecialtiesFlag(false);
    if (isEmpty(FirstName)) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (isEmpty(LastName)) {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (isEmpty(ContactEmail)) {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    } else if (isEmpty(Addresses?.FirstLine)) {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (isEmpty(Addresses?.City)) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (isEmpty(Addresses?.State)) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (isEmpty(Addresses?.PostalCode)) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (isEmpty(Addresses?.Phone)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    } else if (isInvalidPostalCode(Addresses?.PostalCode)) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    }
    if(!validEmail(ContactEmail)){
        setInvalidContactEmail(true);
        document.getElementById("ContactEmail").scrollIntoView();
        document.getElementById("ContactEmail").focus();
        return;
    }
      setInvalidContactEmail(false);
    let phone = Addresses.Phone.replace(/[^0-9]/g, "").substring(0, 10);
    let phonExt = Addresses.PhoneExt ? Addresses.PhoneExt : "";
    let fax = Addresses.Fax?.replace(/[^0-9]/g, "").substring(0, 10);
    if (!isEmpty(phone) && phone.length != 10) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }
    if (!isEmpty(fax) && fax.length != 10) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    }
    SetFrmSubmFlag(false);
    let FaxExt = Addresses.FaxExt ? Addresses.FaxExt : "";
    Addresses.Phone = `${phone}${phonExt}`;
    Addresses.Fax = `${fax}${FaxExt}`;
    Addresses.Country = "USA";
    let vals = {
      ...sharedObject.editObj,
      Addresses: [Addresses],
      FirstName: FirstName,
      LastName: LastName,
      ContactEmail: ContactEmail,
      Credential: Credential,
      FullName: `${FirstName} ${LastName}`,
    };
    vals.Specialties = sharedObject?.specialties?.Code
      ? [sharedObject?.specialties]
      : null;
    SetProcessing(true);
    let call =
      "/users/UpdateUser?specializationCode=" + sharedObject?.specialties?.Code;
    const res = await CallAPI(call, vals, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      SetFlag("success");
      closeEdit(true);
      CloseModal();
    } else if (res.status === "SERVERERROR") {
      SetFlag("error");
      SetProcessing(false);
    }
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $("#editUserModal").modal("hide");
    modalTriggerRef.current?.focus();
    };
  const modalTriggerRef = useRef(null);
    // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close any open modal
        if ($("#editUserModal").hasClass("show")) CloseModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="EditUser">
      <div
        className="modal fade"
        data-backdrop="false"
        id="editUserModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editUserModalTitle"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="editUserModalTitle"
              >
                User Edit
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close User Edit"
                onClick={(e) => {
                  SetspecialtiesFlag(false);
                  CloseModal();
                  ClearFields();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form className="needs-validation" noValidate aria-describedby="formInstructions">
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <img src={UserBadge} alt="Medical Information Icon" />
                    <div className="blk-clr">
                      <label id="userNameDisplayLabel" tabIndex="0">{UserNameDisplay}</label>
                    </div>
                  </div>
                  <hr />
                  {/*User Info*/}
                  <div className="field-wrapper field-box6">
                    {/*Prefix*/}
                    <label htmlFor="NamePrefix">Prefix</label>
                    <select
                      className="form-control"
                      name="NamePrefix"
                      id="NamePrefix"
                      onChange={(el) => setNamePrefix(el.target.value)}
                      value={NamePrefix}
                    >
                      <option value="">Select</option>
                      <option value="Prof">Prof</option>
                      <option value="Dr">Dr</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Miss">Miss</option>
                    </select>
                  </div>
                  {/*First Name*/}
                  <div className="field-wrapper field-box2 sp-mx1">
                    <label htmlFor="FirstName">First Name</label>
                    <input
                      type="text"
                      id="FirstName"
                      className="form-control"
                      value={FirstName}
                      onChange={(el) => setFirstName(el.target.value)}
                      disabled
                      aria-required="true"
                      aria-invalid={FirstName === "" && frmSubmFlag}
                    />
                    {FirstName === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        First name is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Last Name*/}
                  <div className="field-wrapper field-box2">
                    <label htmlFor="LastName">Last Name</label>
                    <input
                      id="LastName"
                      type="text"
                      className="form-control"
                      value={LastName}
                      onChange={(el) => setLastName(el.target.value)}
                      disabled
                      aria-required="true"
                      aria-invalid={LastName === "" && frmSubmFlag}
                    />
                    {LastName === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Last name is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Credential*/}
                  <div className="field-wrapper field-box3 w-md11">
                    <label htmlFor="Credential">Credential</label>
                    <input
                      className="form-control"
                      name="Credential"
                      id="Credential"
                      placeholder="Optional"
                      value={Credential}
                      onChange={(el) => setCredential(el.target.value)}
                      aria-describedby="credentialHelp"
                    />
                    <span id="credentialHelp" className="sr-only">
                      Credential is optional.
                    </span>
                  </div>

                  {/*Contact Email*/}
                  <div className="field-wrapper">
                    <label htmlFor="ContactEmail">Contact Email</label>
                    <input
                      className="form-control"
                      name="ContactEmail"
                      id="ContactEmail"
                      value={ContactEmail}
                      onChange={(el) => setContactEmail(el.target.value)}
                      required
                      aria-required="true"
                      aria-invalid={ContactEmail === "" && frmSubmFlag}
                      type="email"
                    />
                    {ContactEmail === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Contact Email is required.
                      </div>
                    ) : null}
                    {invalidContactEmail && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Please enter a valid email name with more than 4 characters
                        long, no spaces, commas, or special characters.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 1*/}
                  <div className="field-wrapper field-box2">
                    <label htmlFor="FirstLine">Address 1</label>
                    <input
                      className="form-control"
                      name="FirstLine"
                      id="FirstLine"
                      value={Addresses?.FirstLine}
                      onChange={(el) =>
                        setAnswer("FirstLine", el.target.value, true)
                      }
                      aria-required="true"
                      aria-invalid={isEmpty(Addresses?.FirstLine) && frmSubmFlag}
                    />
                    {isEmpty(Addresses?.FirstLine) && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Address is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 2*/}
                  <div className="field-wrapper field-box3 w-md11">
                    <label htmlFor="SecondLine">Address 2</label>
                    <input
                      className="form-control"
                      name="SecondLine"
                      id="SecondLine"
                      placeholder="Optional"
                      value={Addresses?.SecondLine}
                      onChange={(el) =>
                        setAnswer("SecondLine", el.target.value, true)
                      }
                      aria-describedby="address2Help"
                    />
                    <span id="address2Help" className="sr-only">
                      Address 2 is optional.
                    </span>
                  </div>
                  {/*City*/}
                  <div className="field-wrapper">
                    <label htmlFor="City">City</label>
                    <input
                      className="form-control"
                      name="City"
                      id="City"
                      value={Addresses?.City}
                      onChange={(el) =>
                        setAnswer("City", el.target.value, true)
                      }
                      aria-required="true"
                      aria-invalid={Addresses?.City === "" && frmSubmFlag}
                    />
                    {Addresses?.City === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        City is required.
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper">
                    {/*State*/}
                    <div className="field-box5">
                      <label htmlFor="edit-user-state">State</label>
                      <select
                        className="form-control"
                        name="State"
                        id="edit-user-state"
                        value={Addresses?.State}
                        onChange={(el) =>
                          setAnswer("State", el.target.value, true)
                        }
                        aria-required="true"
                        aria-invalid={Addresses?.State === "" && frmSubmFlag}
                      >
                        <option value={""}>Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*PostalCode Code*/}
                    <div className="org-contact-wrapper field-ext">
                      <label htmlFor="PostalCode">Zip</label>
                      <input
                        className="form-control"
                        id="PostalCode"
                        name="PostalCode"
                        maxLength={5}
                        value={Addresses?.PostalCode}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setAnswer("PostalCode", onlyNums, true);
                        }}
                        aria-required="true"
                        aria-invalid={
                          (frmSubmFlag && isEmpty(Addresses?.PostalCode)) ||
                          (frmSubmFlag && isInvalidPostalCode(Addresses?.PostalCode))
                        }
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                    </div>
                    {Addresses?.State === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        State is required.
                      </div>
                    ) : null}
                    {frmSubmFlag && isEmpty(Addresses?.PostalCode) ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Zip Code is required.
                      </div>
                    ) : frmSubmFlag &&
                      isInvalidPostalCode(Addresses?.PostalCode) ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">Invalid Zip Code</div>
                    ) : null}
                  </div>
                  {/*Phone*/}
                  <div className="field-wrapper ">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Phone">Phone</label>
                      <input
                        className="form-control"
                        id="Phone"
                        name="Phone"
                        onChange={(e) =>
                          setAnswer("Phone", e.target.value, true)
                        }
                        value={formatPhoneNumber(Addresses?.Phone)}
                        aria-required="true"
                        aria-invalid={
                          (Addresses?.Phone === "" && frmSubmFlag) ||
                          (Addresses?.Phone !== "" &&
                            Addresses?.Phone?.length < 14 &&
                            frmSubmFlag)
                        }
                        inputMode="tel"
                        pattern="[0-9]*"
                      />
                      {Addresses?.Phone === "" && frmSubmFlag ? (
                        <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Phone number is required.
                        </div>
                      ) : null}
                      {Addresses?.Phone !== "" &&
                      Addresses?.Phone?.length < 14 &&
                      frmSubmFlag ? (
                        <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Invalid Phone Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="PhoneExt">Ext</label>
                      <input
                        className="form-control"
                        name="PhoneExt"
                        id="PhoneExt"
                        maxLength={5}
                        value={Addresses?.PhoneExt}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setAnswer("PhoneExt", onlyNums, true);
                        }}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        aria-describedby="phoneExtHelp"
                      />
                      <span id="phoneExtHelp" className="sr-only">
                        Phone extension, optional.
                      </span>
                    </div>
                  </div>
                  {/*Fax*/}
                  <div className="field-wrapper">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Fax">Fax</label>
                      <input
                        className="form-control"
                        id="Fax"
                        name="Fax"
                        placeholder="Optional"
                        onChange={(el) =>
                          setAnswer("Fax", el.target.value, true)
                        }
                        value={formatPhoneNumber(Addresses?.Fax)}
                        inputMode="tel"
                        pattern="[0-9]*"
                        aria-describedby="faxHelp"
                        aria-invalid={
                          Addresses?.Fax?.length < 14 &&
                          frmSubmFlag &&
                          Addresses?.Fax?.length > 0
                        }
                      />
                      <span id="faxHelp" className="sr-only">
                        Fax number, optional.
                      </span>
                      {Addresses?.Fax?.length < 14 &&
                      frmSubmFlag &&
                      Addresses?.Fax?.length > 0 ? (
                        <div className="alert alert-danger" role="alert">
                          Invalid Fax Number
                        </div>
                      ) : null}
                    </div>
                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="FaxExt">Ext</label>
                      <input
                        className="form-control"
                        name="FaxExt"
                        id="FaxExt"
                        maxLength={5}
                        value={Addresses?.FaxExt}
                        disabled={
                          Addresses?.Fax?.replace(/[^0-9]/g, "").length === 0
                        }
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setAnswer("FaxExt", onlyNums, true);
                        }}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        aria-describedby="faxExtHelp"
                      />
                      <span id="faxExtHelp" className="sr-only">
                        Fax extension, optional.
                      </span>
                    </div>
                  </div>
                  {/*Specialty*/}
                  <div className="field-wrapper label-divider">
                    <h6 className="sp-pad9 spacer-inline" id="specialtyLabel">
                      Specialty
                    </h6>
                  </div>
                  <div className="field-wrapper text-reg" id="formInstructions">
                    If you select a type, then you must select both
                    classification and specialization.
                  </div>
                  <div className="field-wrapper">
                    <SpecialtyDropdown
                      aria-labelledby="specialtyLabel"
                      SpecialFormFields={(el, val) =>
                        SpecialFormFields(el, val)
                      }
                      editObj={specialtiesObj}
                    />
                  </div>
                  {specialtiesFlag && frmSubmFlag ? (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                      All three specialty categories must be selected.
                    </div>
                  ) : null}
                </div>

                {flag === "success" ? (
                  <div className="alert alert-success" role="alert" aria-live="assertive" aria-atomic="true">
                    User profile has been updated successfully.
                  </div>
                ) : null}
                {flag === "error" ? (
                  <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                    We cannot save your settings at this time. If the problem
                    persists please contact your administrator.
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updateUser}
                  aria-label="Update user"
                  aria-busy={processing}
                  disabled={processing}
                >
                  {processing ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  disabled={processing}
                  onClick={(e) => {
                    SetspecialtiesFlag(false);
                    CloseModal();
                    SetFrmSubmFlag(false);
                    ClearFields();
                  }}
                >
                  Cancel
                </button>
              </div>
             
            {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="edit-user-loader"
            >
              <div className="spinner" aria-hidden="true"></div>
              <div className="loading-text" id="edit-user-loader">{loadingText}</div>
            </div>
            )}
            
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
